var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4101_22645",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 39
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#5C40F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4101_22645)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74141 2.74148C0.0819394 5.40096 0.00237822 9.63282 0 17.9398C7.44431 17.9398 12.0922 14.7438 16.1691 11.9403C19.3542 9.75029 22.1907 7.79978 25.74 7.79978C31.0227 7.79978 35.6353 11.535 38.0811 13.5155C38.426 13.7948 38.7278 14.0392 38.9824 14.2333C38.9052 8.31068 38.4897 4.9727 36.2585 2.74148C33.517 1.30177e-06 29.1047 9.07859e-07 20.2799 1.36379e-07L18.7199 0C9.89523 2.20399e-06 5.48288 1.85967e-06 2.74141 2.74148ZM17.5734 38.9998C17.9471 39.0001 18.3292 39.0001 18.72 39.0001H20.2799H20.28C20.6707 39.0001 21.0528 39.0001 21.4265 38.9998H17.5734Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44921e-05 17.9398C7.4444 17.9397 12.0923 14.7437 16.1692 11.9403C19.3542 9.75025 22.1908 7.79974 25.74 7.79974C31.0228 7.79974 35.6353 11.5349 38.0811 13.5155C38.426 13.7948 38.7279 14.0392 38.9824 14.2333C39 15.5878 39 17.0775 39 18.72V20.28C39 29.1047 39 33.517 36.2586 36.2585C33.6384 38.8787 29.4921 38.9946 21.4263 38.9998H17.5737C9.50793 38.9946 5.3616 38.8787 2.74148 36.2585C-1.1158e-06 33.517 -7.79169e-07 29.1047 8.31789e-10 20.28L3.96011e-07 18.72C3.96011e-07 18.456 3.92035e-07 18.1959 7.44921e-05 17.9398Z",
    fill: "#F45FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2253 19.8803C30.2253 18.9164 31.0165 18.1351 31.9803 18.1351C32.9442 18.1351 33.7353 18.9164 33.7353 19.8803V26.9198C33.7353 27.8837 32.9442 28.6651 31.9803 28.6651C31.0165 28.6651 30.2253 27.8837 30.2253 26.9198V19.8803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9854 15.3953C23.9854 14.4315 24.7765 13.6501 25.7404 13.6501C26.7042 13.6501 27.4954 14.4315 27.4954 15.3953V31.4049C27.4954 32.3687 26.7042 33.1501 25.7404 33.1501C24.7765 33.1501 23.9854 32.3687 23.9854 31.4049V15.3953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7451 19.8803C17.7451 18.9164 18.5362 18.1351 19.5001 18.1351C20.464 18.1351 21.2551 18.9164 21.2551 19.8803V26.9198C21.2551 27.8837 20.464 28.6651 19.5001 28.6651C18.5362 28.6651 17.7451 27.8837 17.7451 26.9198V19.8803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5046 22.4152C11.5046 21.4513 12.2958 20.6699 13.2596 20.6699C14.2235 20.6699 15.0146 21.4513 15.0146 22.4152V24.3847C15.0146 25.3486 14.2235 26.1299 13.2596 26.1299C12.2958 26.1299 11.5046 25.3486 11.5046 24.3847V22.4152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2644 22.4152C5.2644 21.4513 6.05556 20.6699 7.01941 20.6699C7.98329 20.6699 8.77441 21.4513 8.77441 22.4152V24.3847C8.77441 25.3486 7.98329 26.1299 7.01941 26.1299C6.05556 26.1299 5.2644 25.3486 5.2644 24.3847V22.4152Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.c5186fd074dec205866ecc5c6b5a1811.svg";
export { ForwardRef as ReactComponent };